class LWSwiper extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
    }

    connectedCallback() {
        this.render();
    }

    static get observedAttributes() {
        return ['speed'];
    }

    render() {
        const speed = this.getAttribute('speed') || '0.3s';

        this.shadowRoot.innerHTML = /* html */ `
        <style>
            :host {
                display: block;
                position: relative;
                box-sizing: border-box;
                /* We geven de speed door aan een CSS variabele */
                --swiper-speed: ${speed};
            }

            .swiper-wrapper {
                display: flex;
                align-items: center;
                position: relative;
                width: 100%;
            }

            .swiper-container {
                display: flex;
                align-items: stretch; /* FIX 1: Zorgt dat alle flex-items even hoog worden */
                overflow-x: auto;
                scroll-snap-type: x mandatory;
                scroll-behavior: smooth; 
                scrollbar-width: none;
                width: 100%;
                gap: 0; 
            }

            .swiper-container::-webkit-scrollbar { 
                display: none; /* Chrome/Safari */
            }

            /* Styling voor de items binnen de swiper */
            ::slotted(*) {
                min-width: 100%; 
                flex: 0 0 100%;
                scroll-snap-align: start;
                
                display: flex;       /* FIX 2: Maakt van de slot-omgeving een flex-box */
                flex-direction: column; /* Zorgt dat de inhoud verticaal blijft */
                height: auto;        /* Laat flexbox de hoogte bepalen */
            }

            /* Pas op desktop de breedte weer aan */
            @media (min-width: 768px) {
                .swiper-container {
                    gap: 15px; /* Breng de tussenruimte terug op desktop */
                }
                ::slotted(*) { 
                    min-width: calc(33.333% - 10px);
                    flex: 0 0 calc(33.333% - 10px); 
                }
            }
            /* Navigatie Knoppen - Altijd bovenop en klikbaar */
            .nav-btn {
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                background: white;
                border: 1px solid #ddd;
                border-radius: 50%;
                width: 44px;
                height: 44px;
                cursor: pointer;
                z-index: 100;
                display: flex;
                align-items: center;
                justify-content: center;
                box-shadow: 0 4px 12px rgba(0,0,0,0.15);
                pointer-events: all; /* Essentieel voor desktop kliks */
                font-size: 1.2rem;
                transition: background 0.2s, scale 0.1s;
            }

            .nav-btn:hover { background: #f0f0f0; }
            .nav-btn:active { scale: 0.95; }

            .prev { left: -22px; }
            .next { right: -22px; }

            /* Desktop aanpassingen */
            @media (min-width: 768px) {
                ::slotted(*) { 
                    flex: 0 0 calc(33.333% - 10px); 
                    scroll-snap-align: start;
                }
                .prev { left: -10px; }
                .next { right: -10px; }
            }

            /* Verberg knoppen op mobiel (optioneel, swipen is daar fijner) */
            @media (max-width: 480px) {
                .nav-btn { display: none; }
                .swiper-container { padding: 10px 20px; }
            }
        </style>

        <div class="swiper-wrapper">
            <button class="nav-btn prev" aria-label="Vorige">❮</button>
            
            <div class="swiper-container">
                <slot></slot>
            </div>

            <button class="nav-btn next" aria-label="Volgende">❯</button>
        </div>
        `;

        this.setupNavigation();
    }

    setupNavigation() {
        const container = this.shadowRoot.querySelector('.swiper-container');
        const prevBtn = this.shadowRoot.querySelector('.prev');
        const nextBtn = this.shadowRoot.querySelector('.next');

        if (!container || !prevBtn || !nextBtn) return;

        const scroll = (direction) => {
            // We scrollen op basis van de breedte van de container
            // Op desktop 1/3e, op mobiel bijna de hele breedte
            const scrollAmount = container.clientWidth * 0.8;
            
            container.scrollBy({ 
                left: direction === 'next' ? scrollAmount : -scrollAmount, 
                behavior: 'smooth' 
            });
        };

        nextBtn.onclick = (e) => {
            e.stopPropagation();
            scroll('next');
        };

        prevBtn.onclick = (e) => {
            e.stopPropagation();
            scroll('prev');
        };
    }
}

customElements.define('lw-swiper', LWSwiper);